export default __webpack_public_path__ + "media/images/logo_white-4ff9981801e644cebaca2c78cde87e4a.png";